import qs from "qs";
import {apiVoissa} from "../../libs/api";
//import {fetchCurrentUser as oldFetchCurrentUser} from "../../creators/currentUser";
//import store from "../../store";


export const signupUser = (data = {}, config = {}) => apiVoissa.post(`/users`, data, config);
export const loginUser = (data = {}, config = {}) => apiVoissa.post(`/users/login`, data, config);


export const fetchConfirmEmail = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/verify-email`, data, config);
export const fetchConfirmAccount = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/verify-account`, data, config);
export const verifyToken = ({ ephemeralToken = null, currentToken = null}, config = {}) => apiVoissa.post(`/users/accounts/verify-token`, {ephemeralToken, currentToken}, config)
export const forgotPasswordUser = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/forgot-password`, data, config);
export const resetPassword = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/reset-password`, data, config);
export const updateCurrentUserRightModerationTag = (config = {}) => apiVoissa.patch(`/users/me/update-right-moderation-tag`, '', config);


//CURRENT USER

export const fetchUnreadRooms = (config = {}) => apiVoissa.get(`/users/me/rooms/unread`, config);
export const fetchUnreadNotifications = (config = {}) => apiVoissa.get(`/users/me/notifications/unread`, config);

export const fetchCurrentUserQuestions = (query = {}, config = {}) =>  apiVoissa.get(`/users/me/questions?${qs.stringify(query)}`, config);
export const fetchCurrentUserMyQuestions = (query = {}, config = {}) => apiVoissa.get(`/users/me/my-questions?${qs.stringify(query)}`, config);

export const createUserQuestion = (data = {}, config = {}) => apiVoissa.post(`/users/me/questions`, data, config);
export const deleteUserQuestion = (questionId = {}, config = {}) => apiVoissa.delete(`/users/me/questions/${questionId}`, config);

export const requestSuppressionCurrentUser = (data = {}, config = {}) => apiVoissa.delete(`/users/me/request-suppression`, data, config);
export const cancelRequestSuppressionCurrentUser = (config = {}) => apiVoissa.delete(`/users/me/cancel-request-suppression`, config);
export const deleteCurrentUser = (config = {}) => apiVoissa.delete(`/users/me/confirm-suppression`, config);

export const fetchUserIgnored = (query = {}, config = {}) => apiVoissa.get(`/users/me/users-ignored?${qs.stringify(query)}`, config);
export const createUserIgnored = (userId, config = {}) => apiVoissa.post(`/users/me/users-ignored/${userId}`, '', config);
export const deleteUserIgnored = (userId = {}, config = {}) => apiVoissa.delete(`users/me/users-ignored/${userId}`, config);

export const fetchMediaCommentsModeration = (kind = "medias", query = {}, config = {}) => apiVoissa.get(`/users/me/moderation-comments/${kind}?${qs.stringify(query)}`, config);

export const updateCurrentUserPassword = (config = {}) => apiVoissa.post(`/users/me/change-password`, '', config);
export const updateCurrentUserEmail = (data = {}, config = {}) => apiVoissa.patch(`/users/me/update-email`, data, config);
export const updateCurrentUserNotification = (data, config = {}) => apiVoissa.patch(`/users/me/update-notifications`, data, config);

export const updateCurrentUser = (data, config = {}) => apiVoissa.patch(`/users/me`, data, config);

export const updateEmailCurrentUser = (data = {}, config = {}) => apiVoissa.patch(`/users/me/update-emailunconfirmed`, data, config);
export const sendEnrollmentEmailCurrentUser = (data = {}, config = {}) => apiVoissa.patch(`/users/me/send-emailunconfirmed`, data, config);

export const fetchCommentsToModerate = (type, parentId, query, config = {}) => apiVoissa.get(`/users/me/moderation-comments/${type}/${parentId}?${qs.stringify(query)}`, config);

export const fetchCurrentUserAbo = (query = {}, config = {}) => apiVoissa.get(`/users/me/abo`, config);

export const fetchUserCurrent =  (config) => {
    //store.dispatch(oldFetchCurrentUser());
    return apiVoissa.get(`/users/me`, config);
};

// USER

export const fetchUsersStaff = (query = {}, config = {}) =>apiVoissa.get(`/users?staff=true`, config);
export const fetchUsersMeet = (query = {}, config = {}) =>apiVoissa.get(`/meets/users?${qs.stringify(query)}`, config);

export const fetchUsers = (query = {}, config = {}) =>apiVoissa.get(`/users?${qs.stringify(query)}`, config);
export const fetchUser = (userId, config = {}) => apiVoissa.get(`/users/${userId}`, config);
export const setCountViewUser = (userId, config = {}) => apiVoissa.patch(`/users/${userId}/view`, '', config);

export const fetchUserTimelines = (userId, query = {}, privateFeed = false, config = {}) => apiVoissa.get(`/users/${userId}/timelines/${privateFeed ? 'private' : 'public'}?${qs.stringify(query)}`, config);


export const fetchUserWarnings = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/warnings?${qs.stringify(query)}`, config);

export const createUserWarning = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/warnings`, data, config);
export const updateUserWarningAccepted = (userId, warningId = null, config = {}) => apiVoissa.patch(`/users/${userId}/warnings/${warningId}/accepted`, {}, config);
export const deleteUserWarningAccepted = (userId, warningId = null, config  ={}) => apiVoissa.delete(`/users/${userId}/warnings/${warningId}`, config);

export const fetchUserFriends = (userId, query = {}, config) => apiVoissa.get(`/users/${userId}/friends?${qs.stringify(query)}`, config);

export const fetchUserFriendsRequest = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/answers?${qs.stringify(query)}`, config);
export const createUserFriendsRequest = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/answers`, data, config);
export const fetchUserRandomQuestions = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/random-questions?${qs.stringify(query)}`, config);

export const acceptedUserFriendRequest = (userId, answerId, config = {}) => apiVoissa.patch(`/users/${userId}/answers/${answerId}/accepted`, {}, config);
export const refusedUserFriendRequest = (userId, answerId, config = {}) => apiVoissa.patch(`/users/${userId}/answers/${answerId}/refused`, {}, config);

export const updateUserFriendFavorite = (userId, friendId = null, config = {}) => apiVoissa.patch(`/users/${userId}/friends/${friendId}/update-favorite`, {}, config);
export const deleteUserFriend = (userId, friendId = null, config = {}) => apiVoissa.delete(`/users/${userId}/friends/${friendId}`, config);


export const fetchUserStatus = (userId, statusId, query = {}, config = {}) => apiVoissa.get(userId ? `/users/${userId}/status/${statusId}?${qs.stringify(query)}` : `/status/${statusId}?${qs.stringify(query)}`, config);
export const createUserStatus = (userId, data, config = {}) => apiVoissa.post(`/users/${userId}/status/`, data, config);
export const updateUserStatus = (userId, statusId, data = {}, config = {}) => apiVoissa.patch(`/users/${userId}/status/${statusId}`, data, config);
export const deleteUserStatus = (userId, statusId = {}, config = {}) => apiVoissa.delete(`/users/${userId}/status/${statusId}`, config);

export const fetchUserNotificationStatus = (userId, notificationId, config = {}) => apiVoissa.get(`users/${userId}/notifications/${notificationId}/status`,config);

export const fetchUserNotifications = (query = {}, config = {}) => apiVoissa.get(`/users/me/notifications?${qs.stringify(query)}`, config);
export const markUserNotificationOpen = (notificationId = null, config ={}) => apiVoissa.patch(`/users/me/notifications/open/${notificationId}`, {}, config);
export const markUserAllNotificationOpen = (config ={}) => apiVoissa.patch(`/users/me/notifications/open`, {}, config);

export const fetchUserArticles = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/articles?${qs.stringify(query)}`, config);

export const fetchUserAlbums = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/albums?${qs.stringify(query)}`, config);

export const fetchUserAlbum = (userId, albumId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/albums/${albumId}?${qs.stringify(query)}`, config);
export const createUserAlbum = (userId, data, config = {}) => apiVoissa.post(`/users/${userId}/albums`, data, config);
export const updateUserAlbum = (userId, albumId, data, config = {}) => apiVoissa.patch(`/users/${userId}/albums/${albumId}`, data, config);
export const deleteUserAlbum = (userId, albumId = {}, config = {}) => apiVoissa.delete(`/users/${userId}/albums/${albumId}`, config);

export const fetchUserMedias = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/medias?${qs.stringify(query)}`);

export const fetchUserMediasSfw = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/medias-sfw?${qs.stringify(query)}`);

export const createFollowingUser = (userId, profileId, config = {}) => apiVoissa.post(`/users/${userId}/following-profile/${profileId}`, config);
export const deleteFollowingUser = (userId, profileId, config = {}) => apiVoissa.delete(`/users/${userId}/following-profile/${profileId}`, config);

export const fetchUserBestVideos = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/best-medias?${qs.stringify(query)}`, config);
export const fetchUserBestPhotos = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/best-medias?${qs.stringify(query)}`, config);

export const fetchUserFollowings = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/followings?${qs.stringify(query)}`, config);
export const fetchUserFollowers = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/followers?${qs.stringify(query)}`, config);

export const reportUser = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/reporting`, data, config);

export const fetchUserByIp = (data = {}, config = {}) => apiVoissa.post(`/users/find-ip`, data, config);

export const fetchUserLastVisitors = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/last-visitors?${qs.stringify(query)}`, config);

export const fetchUserSessions = (userId = null, config = {}) => apiVoissa.get(`/users/${userId}/sessions-group`, config);

export const USER_TOKEN_KEY = `user-token`;
export const USER_SET_COUNT_VIEW = `user-set-count-view`;
export const USER_CURRENT_KEY = `user-current`;
export const USER_KEY = `user`;
export const USER_UNREAD_ROOMS_KEY = `user-unread-rooms`;
export const USER_UNREAD_NOTIFICATIONS_KEY = `user-unread-notifications`;
export const USER_CURRENT_QUESTIONS_KEY = `user-current-questions`;
export const USER_CURRENT_MY_QUESTIONS_KEY = `user-current-my-questions`;
export const USER_CURRENT_IGNORE_KEY = `user-current-users-ignore`;
export const USER_CURRENT_COMMENTS_MODERATION_KEY = `user-current-comments-moderation`;
export const USER_CURRENT_CLICK_CTA_KEY = `user-current-click-cta`;

export const USER_CURRENT_MODERATION_COMMENTS_MEDIAS_KEY = `user-current-moderation-comments-medias`;
export const USER_CURRENT_MODERATION_COMMENTS_ARTICLES_KEY = `user-current-moderation-comments-articles`;

export const USER_WARNINGS_KEY = `user-warnings`;
export const USER_FRIENDS_KEY = `user-friends`;
export const USER_FRIENDS_SEARCH_KEY = `user-friends-search`;
export const USER_FRIENDS_REQUEST_KEY = `user-friends-request`;
export const USER_FRIENDS_QUESTIONS_KEY = `user-friends-questions`;

export const USER_STATUS_KEY = `user-status`;
export const USER_NOTIFICATION_STATUS_KEY = `user-notification-status`;
export const USER_NOTIFICATIONS_KEY = `user-notifications`;
export const USER_ARTICLES_KEY = `user-articles`;
export const USER_ALBUMS_KEY = `user-albums`;
export const USER_ALBUM_KEY = `user-album`;
export const USER_MEDIAS_KEY = `user-medias`;
export const USER_MEDIAS_SFW_KEY = `user-medias-sfw`;
export const USER_BEST_VIDEOS_KEY = `user-best-videos`;
export const USER_BEST_PHOTOS_KEY = `user-best-photos`;

export const USER_FIL_ACTUALITY_KEY = `user-fil-actuality`;

export const USER_FOLLOWERS_KEY = `user-followers`;
export const USER_FOLLOWINGS_KEY = `user-followings`;
export const USER_LAST_VISITORS_KEY = `user-last-visitors`;

export const USER_LIST_USERS_BY_IP_KEY = `user-list-users-by-ip`;

export const USER_LIST_SESSION_KEY = `user-list-session`;

export const USERS_KEY = `users`;
export const USERS_STAFF_KEY = `users-staff`;
export const USERS_MEET_KEY = `users-meet`;
